import { connect } from 'react-redux';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { MOBILE_TRAVEL_PLAN } from '../../products';
import MainMobileTravelPlan from './MainMobileTravelPlan';
import SmallMobileTravelPlan from './SmallMobileTravelPlan';
import { jsx as _jsx } from "react/jsx-runtime";
const MobileTravelPlan = props => {
  switch (props.layoutType) {
    case ProductCardLayoutType.Small:
      return /*#__PURE__*/_jsx(SmallMobileTravelPlan, {
        ...props
      });
    case ProductCardLayoutType.Main:
    default:
      return /*#__PURE__*/_jsx(MainMobileTravelPlan, {
        ...props
      });
  }
};
const mapStateToProps = (state, _ref) => {
  let {
    form
  } = _ref;
  return {
    isSelected: getSelected(MOBILE_TRAVEL_PLAN.name, form)(state)
  };
};
export default connect(mapStateToProps)(MobileTravelPlan);
//# sourceMappingURL=MobileTravelPlan.js.map